import(/* webpackMode: "eager" */ "/vercel/path0/src/app/feed/page.tsx");
